<template>
    <div>
            <div class="markdown">
              <span v-html="definition_html"></span>
            </div>
    </div>
    
</template>

<script>
    export default {
        name: "ReportCompSectionBreak",
        props: ['definition','additional_filters', 'snapshotId'],
        watch: {
            additional_filters: function () {
                if (this.definition.big_numbers) {
                  this.loadDefinition()
                }
            },
            snapshotId: function () {
              if (this.definition.big_numbers) {
                this.loadDefinition()
              }
            },
            definition: function() {
              if (this.definition.big_numbers) {
                this.loadDefinition()
              }
            }
        },
        mounted() {
            this.definition_html = this.definition.html
        },
        methods: {
          loadDefinition() {
            // /reports/comps/{report}/{component}

            axios.get('/reports/comps/' + this.definition.report_id + '/' + this.definition.id,{
              params: {
                additional_filters: this.additional_filters,
                snapshotId: this.snapshotId
              }
            })
                .then(response => {
                  console.log('got more data')
                  this.definition_html = response.data.html
                })
                .catch(error => {
                  console.log('could not load report comp')
                })
          },
        },
        data() {
          return {
            definition_html: null,
          }
        }
    }
</script>

<style scoped>

</style>